import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { SITE } from '../data/site';
import { SERVICES } from '../data/services';
import { LOCATIONS } from '../data/locations';

const Footer = () => (
  <footer data-testid="site-footer" className="noise-dark border-t border-paper/10 bg-graphite text-paper">
    <div className="container-site relative z-10 py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" data-testid="footer-logo" className="inline-block">
            <img src="/images/logo-light.png" alt="Nebraska Backyard Living" className="h-11 w-auto" />
          </Link>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-paper/60">
            Locally owned and operated ({SITE.legalName}). For over 22 years we've designed and built custom outdoor living spaces — kitchens, sunrooms, decks, pergolas, patios, and water &amp; fire features — across the Omaha and Lincoln metro areas.
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <a href={SITE.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-paper/80 transition-colors hover:text-bronzelight">
              <Phone className="h-4 w-4 text-bronze" /> {SITE.phone}
            </a>
            <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 text-paper/80 transition-colors hover:text-bronzelight">
              <Mail className="h-4 w-4 text-bronze" /> {SITE.email}
            </a>
            <p className="flex items-center gap-3 text-paper/80">
              <MapPin className="h-4 w-4 text-bronze" /> Serving the {SITE.serviceArea}
            </p>
          </div>
          <Link to="/get-a-quote/" data-testid="footer-quote-cta" className="btn-primary mt-8">Get a Free Quote</Link>
        </div>

        <div className="lg:col-span-2">
          <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-bronzelight">Services</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-paper/60">
            {SERVICES.slice(0, 7).map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}/`} data-testid={`footer-service-${s.slug}`} className="transition-colors hover:text-paper">{s.navTitle}</Link>
              </li>
            ))}
            <li><Link to="/services/" data-testid="footer-services-all" className="font-semibold text-paper/80 transition-colors hover:text-bronzelight">All Services →</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-bronzelight">Service Areas</h3>
          <ul className="mt-5 grid grid-cols-2 gap-2.5 text-sm text-paper/60">
            {LOCATIONS.map((l) => (
              <li key={l.slug}>
                <Link to={`/service-areas/${l.slug}/`} data-testid={`footer-area-${l.slug}`} className="transition-colors hover:text-paper">{l.city}, NE</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h3 className="text-xs font-semibold uppercase tracking-[0.25em] text-bronzelight">Company</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-paper/60">
            <li><Link to="/about/" data-testid="footer-about" className="transition-colors hover:text-paper">About Us</Link></li>
            <li><Link to="/projects/" data-testid="footer-projects" className="transition-colors hover:text-paper">Projects</Link></li>
            <li><Link to="/blog/" data-testid="footer-blog" className="transition-colors hover:text-paper">Blog</Link></li>
            <li><Link to="/contact/" data-testid="footer-contact" className="transition-colors hover:text-paper">Contact</Link></li>
            <li><Link to="/get-a-quote/" data-testid="footer-get-quote" className="transition-colors hover:text-paper">Get a Free Quote</Link></li>
          </ul>
          <h3 className="mt-8 text-xs font-semibold uppercase tracking-[0.25em] text-bronzelight">Legal</h3>
          <ul className="mt-5 space-y-2.5 text-sm text-paper/60">
            <li><Link to="/privacy-policy/" data-testid="footer-privacy" className="transition-colors hover:text-paper">Privacy Policy</Link></li>
            <li><Link to="/terms/" data-testid="footer-terms" className="transition-colors hover:text-paper">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-3 border-t border-paper/10 pt-8 text-xs text-paper/40 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} {SITE.name} ({SITE.legalName}). All rights reserved.</p>
        <p>{SITE.years}+ Years · Locally Owned · {SITE.rating} · Licensed &amp; Insured</p>
      </div>
    </div>
  </footer>
);

export default Footer;
